module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7pPEO"))).then(() => parcelRequire('1iHdE'));